(function(){
    // Vanilla Dynamic Highcharts binder
    var SELECTOR = '[data-auto-bind-chart="true"], [data-auto-bind-chart="auto"]';

    function isBound(el){
        return el.getAttribute('data-chart-bound') === 'true';
    }
    function markBound(el){
        el.setAttribute('data-chart-bound','true');
    }

    function waitForHighcharts(cb, attempts){
        attempts = attempts || 0;
        if (window.Highcharts && typeof window.bindChart === 'function') { cb(); return; }
        if (attempts > 100) { cb(); return; }
        setTimeout(function(){ waitForHighcharts(cb, attempts+1); }, 50);
    }

    function bindIfNeeded(el){
        if (!el || isBound(el)) return;
        waitForHighcharts(function(){
            try {
                if (window.Highcharts && typeof window.bindChart === 'function') {
                    window.bindChart(el);
                }
            } catch (e) {}
            markBound(el);
        });
    }

    function setupIntersectionObserver(){
        if (!('IntersectionObserver' in window)) return null;
        var io = new IntersectionObserver(function(entries){
            entries.forEach(function(entry){
                if (entry.isIntersecting || entry.intersectionRatio > 0) {
                    var el = entry.target;
                    io.unobserve(el);
                    bindIfNeeded(el);
                }
            });
        }, {rootMargin: '200px 0px', threshold: [0, 0.01]});
        return io;
    }

    function registerElements(io, root){
        var scope = root || document;
        var nodes = scope.querySelectorAll(SELECTOR);
        if (!nodes || !nodes.length) return;
        for (var i=0;i<nodes.length;i++){
            var el = nodes[i];
            if (isBound(el)) continue;
            if (io) io.observe(el); else bindIfNeeded(el);
        }
    }

    function setupMutationObserver(io){
        if (!('MutationObserver' in window)) return;
        try {
            var mo = new MutationObserver(function(mutations){
                mutations.forEach(function(m){
                    if (m.type === 'childList' && m.addedNodes && m.addedNodes.length){
                        for (var i=0;i<m.addedNodes.length;i++){
                            var node = m.addedNodes[i];
                            if (node.nodeType !== 1) continue;
                            if (node.matches && node.matches(SELECTOR)) {
                                if (io) io.observe(node); else bindIfNeeded(node);
                            }
                            registerElements(io, node);
                        }
                    }
                });
            });
            mo.observe(document.documentElement || document.body, {childList:true, subtree:true});
        } catch(e) { }
    }

    function init(){
        var start = function(){
            var io = setupIntersectionObserver();
            registerElements(io, document);
            setupMutationObserver(io);
        };
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', start);
        } else {
            start();
        }
    }

    init();
})();
